import {ExpandedChecksList} from '@github-ui/mergebox/components/sections/checks/ExpandedChecksList'
import type {StatusCheck, StatusRollup} from '@github-ui/mergebox/page-data/payloads/status-checks'
import {MergeBoxExpandable} from '@github-ui/mergebox/components/sections/common/MergeBoxExpandable'
import styles from './ChecksSection.module.css'
import type {MergeBoxPullRequest} from '../use-mergeability-data'
import {usePullRequestAnalytics} from '../../../../../hooks/use-pull-request-analytics'
import {useCallback} from 'react'
import {clsx} from 'clsx'

interface ChecksSectionProps {
  statusChecks: StatusCheck[]
  mergeBoxPullRequest: MergeBoxPullRequest
  statusRollup: StatusRollup
  itemName: string
  transparentBackground?: boolean
}

export function ChecksSection({
  statusChecks,
  mergeBoxPullRequest,
  statusRollup,
  itemName,
  transparentBackground = false,
}: ChecksSectionProps) {
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()
  const sendChecksAction = useCallback(
    (actionName: string) =>
      sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
        item_name: itemName,
        action_name: actionName,
      }),
    [itemName, sendPullRequestAnalyticsEvent],
  )

  return (
    <div>
      <MergeBoxExpandable
        isExpanded
        wrapperClassName={clsx(styles.wrapper, transparentBackground && styles.transparentBackground)}
        contentClassName={styles.content}
      >
        <ExpandedChecksList
          statusChecks={statusChecks}
          statusRollupSummary={statusRollup.summary}
          mergeBoxUserPreferences={mergeBoxPullRequest.mergeBoxUserPreferences}
          viewerCanUseCopilotCodingAgent={mergeBoxPullRequest.viewerCanUseCopilotCodingAgent}
          viewerHasCEOrCBAccess={mergeBoxPullRequest.viewerHasCEOrCBAccess}
          onActionSelect={sendChecksAction}
        />
      </MergeBoxExpandable>
    </div>
  )
}
